var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNewFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66671 2.33325C1.93033 2.33325 1.33337 2.93021 1.33337 3.66659V12.3333C1.33337 13.0696 1.93033 13.6666 2.66671 13.6666H13.3334C14.0698 13.6666 14.6667 13.0696 14.6667 12.3333V5.66659C14.6667 4.93021 14.0698 4.33325 13.3334 4.33325H8.66671L7.80838 2.95992C7.56472 2.57008 7.13743 2.33325 6.67771 2.33325H2.66671Z",
    fill: "#3272D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewFolder);
export default __webpack_public_path__ + "static/media/ic_new_folder.5873c460.svg";
export { ForwardRef as ReactComponent };